<div class="modal-overlay">
  <div
    class="modal-content"
    [ngStyle]="{
      overflow: overflow,
      top: position.y + 'px',
      left: position.x + 'px',
    }"
  >
    @if (showHeader) {
      <div
        class="header"
        [class.drag]="draggable"
        (mousedown)="onDragStart($event)"
      >
        <div class="title-container">
          @if (showImage) {
            <div class="image">
              <img [src]="imageUrl" alt="union image" />
            </div>
          }
          <h4 class="title">{{ title }}</h4>
        </div>
        <img
          src="/assets/images/close.svg"
          class="icon img-size"
          (click)="onCloseClicked($event)"
        />
      </div>
    }

    <ng-content class="main-content"></ng-content>

    <div class="button-row">
      @if (secondaryButtonText) {
        <button
          class="button"
          [class.flat]="secondaryButtonFlat"
          [disabled]="isSecondaryButtonDisabled"
          (click)="onSecondaryButtonClicked($event)"
        >
          {{ secondaryButtonText }}
        </button>
      }
      @if (helpButtonText) {
        <button
          class="button"
          [class.flat]="helpButtonFlat"
          (click)="onHelpButtonClicked($event)"
        >
          {{ helpButtonText }}
        </button>
      }
      @if (primaryButtonText) {
        <button
          class="button"
          [class.flat]="primaryButtonFlat"
          [disabled]="isPrimaryButtonDisabled"
          (click)="onPrimaryButtonClicked($event)"
        >
          {{ primaryButtonText }}
        </button>
      }
    </div>
  </div>
</div>
